module.exports = __webpack_public_path__ + "img/gradeF.62d36ab8.png";